var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.resources.length > 0)?_c('h2',[_vm._v("Ready-to-Use Resources")]):_vm._e(),_vm._v(" "),_vm._l((_vm.resources),function(resource){return _c('resource-preview-card',_vm._b({key:resource.uuid},'resource-preview-card',resource,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }